import { makeStyles } from "@fluentui/react-components";
import * as React from "react";
import { CardSection } from "../../components/CardSection"; // Adjust the import path as needed

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        padding: "2rem clamp(1rem, 5vw, 4rem)",
        width: "80%",
        margin: "0 auto",
        maxWidth: "1400px",
    },
});

export const Id = "814e41cb-2fd9-48ef-815c-9f09ef46c576";
export const Title = "Does Ianus limit my offline capabilities?";
export const Subtitle = "Find out whether Ianus adds limitations";
export const Description = "Find out whether Ianus adds limitations, also regarding offline";
export const Keywords = ["capabilities", "limitation", "offline"];

export const Component: React.FC = React.memo(() => {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <CardSection title="No Online Dependency">
                Ianus does not impose limitations on your modules beyond license validation.
                <br /><br />
                It is fully offline capable and does not require contact with a license server at runtime. Once a license is issued,
                validation can occur entirely within the local environment.
            </CardSection>

            <CardSection title="Required Offline Entities">
                For offline environments, make sure that the following Dataverse entities are available locally:
                <ul>
                    <li><strong>License (ian_license)</strong></li>
                    <li><strong>Organization</strong></li>
                </ul>
                These are essential for validating licenses during offline operation.
            </CardSection>
        </div>
    );
});
